import React, { createContext, useState, useCallback, useRef } from "react";
import { useApiRequests } from "./services";

export const CartContext = createContext({
  cart: { items: [], total: 0, availableBalance: 0 },
  count: 0,
  refreshCart: () => {},
});

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState({ items: [], total: 0, availableBalance: 0 });
  // De-dupes concurrent refreshes (e.g. Header + Cart mounting together on /cart)
  // into a single in-flight GET /cart; callers awaiting it share the same request.
  const inFlight = useRef(null);

  const refreshCart = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      inFlight.current = null;
      setCart({ items: [], total: 0, availableBalance: 0 });
      return;
    }
    if (inFlight.current) {
      return inFlight.current;
    }
    const { getCart } = useApiRequests();
    const request = (async () => {
      try {
        const response = await getCart();
        // Drop the result if auth changed while the request was in flight
        // (e.g. logout/login), so we never repopulate with a stale session's cart.
        if (
          localStorage.getItem("token") === token &&
          response &&
          response.data
        ) {
          setCart(response.data);
        }
      } catch (error) {
        // axios response interceptor already surfaces the error toast
      } finally {
        inFlight.current = null;
      }
    })();
    inFlight.current = request;
    return request;
  }, []);

  return (
    <CartContext.Provider
      value={{ cart, count: cart.items ? cart.items.length : 0, refreshCart }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
